<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="2" />
    <h4>Registros por forma de pago</h4>
    <hr>
    <form @submit.prevent="fetchPagos">
      <div class="mb-3">
        <div class="row">
          <div class="col-2">
            <label for="fechaDesde">Desde</label>
            <input type="date" v-model="fechaDesde" class="form-control">
          </div>
          <div class="col-2">
            <label for="fechaHasta">Hasta</label>
            <input type="date" v-model="fechaHasta" class="form-control">
          </div>
          <div class="col-4">
            <label for="formaPago">Forma de Pago</label>
            <select v-model="selectedFormaPago" class="form-control" @change="fetchPagos">
              <option v-for="forma in formasPago" :value="forma.idFormaPago" :key="forma.idFormaPago">
                {{ forma.nombre }}
              </option>
            </select>
          </div>
          <div class="col-4">
            <button @click="exportToCSV" class="btn btn-success">Exportar a CSV</button>
          </div>
        </div>
      </div>
    </form>
    <table class="table">
      <thead>
        <tr>          
          <th>Persona</th>
          <th>Id.</th>
          <th>Fecha Registro</th>
          <th style="text-align: right;">Monto</th>
          <th>Referencia</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pago in pagosFiltrados" :key="pago.idPago">
          <td>{{ pago.personaNombre }}</td>
          <td>{{ pago.personaDocumento }}</td>
          <td>{{ formatFecha(pago.fechaReg) }}</td>
          <td style="text-align: right;">{{ pago.monto }}</td>
          <td>{{ pago.referencia }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th colspan="3">Total</th>
          <th style="text-align: right;">{{ totalMonto }}</th>
          <th></th>
        </tr>
      </tfoot>
    </table>
    <Footer />
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import api from "@/services/api";

export default {
  components: {
    Layout, Footer
  },
  data() {
    return {
      formasPago: [],
      selectedFormaPago: '',
      fechaDesde: '',
      fechaHasta: '',
      pagos: [],
      pagosFiltrados: [],
    };
  },
  computed: {
    totalMonto() {
      return this.pagosFiltrados.reduce((total, pago) => total + pago.monto, 0);
    }
  },
  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchFormasPago();
    this.fetchPagos();
  },
  methods: {
    formatFecha(fecha) {
      const fechaObjeto = new Date(fecha);
      const opciones = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return fechaObjeto.toLocaleDateString('es', opciones).split('/').reverse().join('-');
    },
    fetchFormasPago() {
      api.get('/vwformapagos')
        .then(response => {
          this.formasPago = response.data;
        })
        .catch(error => console.error("There was an error fetching the formas de pago: ", error));
    },
    fetchPagos() {
      api.get(`/vwpagoexts/forma-pago?idEmpresa=${window.sessionStorage.getItem("idEmpresa")}&idFormaPago=${this.selectedFormaPago}&fechaDesde=${this.fechaDesde}&fechaHasta=${this.fechaHasta}`)
        .then(response => {
          this.pagos = response.data;
          this.pagosFiltrados = this.pagos; // Aquí puedes aplicar cualquier filtro adicional si es necesario
        })
        .catch(error => console.error("There was an error fetching the pagos: ", error));
    },
    exportToCSV() {
      const selectedFormaPagoText = this.formasPago.find(forma => forma.idFormaPago === this.selectedFormaPago)?.nombre || 'Todos';
      const filename = `export_pagos_${selectedFormaPagoText.replace(/\s+/g, '_').toLowerCase()}.csv`;
      let csvContent = "data:text/csv;charset=utf-8,";
      // Agregar encabezado al CSV
      csvContent += "Persona,Id.,Fecha Registro,Monto,Referencia,Forma de Pago\n";

      // Agregar cada pago como una nueva línea en el CSV
      this.pagosFiltrados.forEach(function(pago) {
        const row = [
          pago.personaNombre,
          pago.personaDocumento,
          pago.fechaReg,
          pago.monto,
          pago.referencia,
          pago.formaPagoNombre
        ].join(',');
        csvContent += row + "\r\n";
      });

      // Calcular el total de los montos
      const totalMonto = this.pagosFiltrados.reduce((acc, pago) => acc + Number(pago.monto), 0);

      // Agregar fila de total al CSV
      csvContent += `,,,Total: ,${totalMonto},\r\n`;

      // Crear un enlace para descargar el CSV
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", filename);
      document.body.appendChild(link); // Necesario para FF

      // Simular click para descargar
      link.click();
      document.body.removeChild(link); // Limpiar
    }

  }
};
</script>